import paper from 'paper';

class DoodleManager {
  drawnPaths: any[];
  currentPath: any;
  eraserPath: any;
  project: any;
  constructor() {
    this.drawnPaths = [];
    this.currentPath = null;
    this.eraserPath = null;
    this.project = null;
  }

  prepareCanvas(canvas) {
    this.project = new paper.Project(canvas);
    this.newPath();
  }

  newPath() {
    this.currentPath = new paper.Path({
      strokeCap: 'round',
      strokeColor: 'grey',
      strokeWidth: 5,
    });

    this.eraserPath = new paper.Path({
      strokeCap: 'square',
      strokeColor: 'black',
      strokeWidth: 10,
      blendMode: 'destination-out',
    });

    this.project.activeLayer.addChild(this.currentPath);
    this.project.activeLayer.addChild(this.eraserPath);
  }

  drawPoint(x, y) {
    this.currentPath.add(new paper.Point(x, y));
    this.currentPath.smooth();
  }

  drawEraserPoint(x, y) {
    this.eraserPath.add(new paper.Point(x, y));
  }

  endPath() {
    this.drawnPaths.push(this.currentPath);
  }

  removeAllDrawnPaths() {
    this.drawnPaths.forEach((path) => path.remove());
    this.drawnPaths = [];
  }
}

export default DoodleManager;
